import { render, staticRenderFns } from "./TooltipInButton.vue?vue&type=template&id=551d8f75"
import script from "./TooltipInButton.vue?vue&type=script&lang=js"
export * from "./TooltipInButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports